import { WeSpinNotificationClient, WeSpinTakeMeToEvent, WeSpinKeepAlive, WeSpinConfiguration } from './async.js';

const WeSpinAppComponents = () => (
	<>
		<WeSpinConfiguration />
		<WeSpinNotificationClient />
		<WeSpinTakeMeToEvent />
		<WeSpinKeepAlive />
	</>
);

export default WeSpinAppComponents;
